export default "__VITE_ASSET__Dr73u$TT__"